import { render } from "./statisticalval.vue?vue&type=template&id=2e13ee76&scoped=true"
import script from "./statisticalval.vue?vue&type=script&lang=js"
export * from "./statisticalval.vue?vue&type=script&lang=js"

import "./statisticalval.vue?vue&type=style&index=0&id=2e13ee76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e13ee76"]])

export default __exports__